module.exports = __webpack_public_path__ + "img/dab_omar.328e38e0.jpg";